import React, { Component } from "react";
import { Grid, Divider } from "semantic-ui-react";
import MessageOfTheDayCard from "./messageoftheday";
import LaborAtAGlanceCard from "./laborglance";
import NoteToSelfCard from "./notetoself";
import MessageSystemCard from "./messagesystem";
import CompanyCalendarCard from "./companycalendar";
import AssignedJobsCard from "./assignedjobs";
import ExpectedAbsences from "./absences";
import AbsenceModal from "./absencemodal";
import "./home.css";
import Motdmodal from "./motdModal";
// import { log } from "util";
class HomeDesktop extends Component {
  render() {
    return (
      <div className="HomeDesktop">
        <Grid divided="vertically">
          <Grid.Row columns={2}>
            <Grid.Column stretched width={8}>
              <MessageOfTheDayCard
                motd={this.props.motd}
                handlemodal={() => this.props.handlemodal("motd")}
              />{" "}
            </Grid.Column>{" "}
            <Grid.Column stretched width={4}>
              <LaborAtAGlanceCard
                weekhours={this.props.weekhours}
                myinfo={this.props.myinfo}
              />{" "}
              <Divider />
              <NoteToSelfCard
                myinfo={this.props.myinfo}
                patchnote={message => this.props.patchnote(message)}
              />{" "}
              <Divider />
              <MessageSystemCard
                showModal={tab => {
                  this.props.messagetab(tab);
                  this.props.handlemodal("messaging");
                }}
                messages={this.props.messages}
                alerts={this.props.alerts}
              />{" "}
            </Grid.Column>{" "}
          </Grid.Row>{" "}
          <Grid.Row columns={2}>
            <Grid.Column width={8}>
              <AssignedJobsCard
                myinfo={this.props.myinfo}
                jobs={this.props.jobs}
                wods={this.props.wods}
                time={this.props.time}
              />{" "}
            </Grid.Column>{" "}
            <Grid.Column width={4}>
              <CompanyCalendarCard />
            </Grid.Column>{" "}
          </Grid.Row>{" "}
          <AbsenceModal
            ref="AM"
            addabsence={abs => {
              abs.empnumber = this.props.myinfo.empnumber;
              return this.props.addabsence(abs);
            }}
            updateabsence={abs => {
              if (this.props.myinfo && this.props.myinfo)
                this.props.updateabsence(abs);
            }}
            handleclose={() => this.props.handlemodal("none")}
            deleteabsence={id => {
              this.props
                .deleteabsence(id)
                .then(() => this.props.handlemodal("none"));
            }}
            showModal={this.props.showabsencemodal}
          />{" "}
          <Grid.Row>
            <Grid.Column width={4}>
              <ExpectedAbsences
                myinfo={this.props.myinfo}
                showabsence={() => this.props.handlemodal("absence")}
                handleapprove={id => {
                  if (this.props.myinfo && this.props.myinfo.hradmin) {
                    this.props.handleapprove(id);
                  }
                }}
                absences={this.props.absences}
                employees={this.props.employees}
                editabsense={absence => {
                  if (this) this.props.handlemodal("absence");
                  this.refs.AM.setState({
                    absence,
                    comments: absence.comments,
                    dateout: absence.dateout,
                    datereturn: absence.datereturn
                  });
                }}
              />{" "}
            </Grid.Column>{" "}
          </Grid.Row>{" "}
          <Motdmodal
            open={this.props.modal === "motd"}
            reloadmotd={() => this.props.reloadmotd()}
            close={() => this.props.handlemodal("none")}
            myinfo={this.props.myinfo}
          />{" "}
        </Grid>{" "}
      </div>
    );
  }
}

export default HomeDesktop;



// WEBPACK FOOTER //
// ./src/components/home-components/homedesktop.js